// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IButtonStyles } from "@fluentui/react";
import type { ISpinButtonStyles } from "@fluentui/react/lib/SpinButton";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import type { ActionControlSize } from "@1js/acui-common";

export interface SpinButtonSizedStyles {
  spinButtonStyles?: Partial<ISpinButtonStyles>;
  buttonStyles?: Partial<IButtonStyles>;
}

const spinButtonSmallStyles: Partial<ISpinButtonStyles> = {
  root: {
    height: 24,
    paddingLeft: 0,
  },
  icon: {
    height: 16,
    width: 16,
    lineHeight: 16,
  },
  label: {
    fontSize: 12,
  },
  labelWrapper: {
    lineHeight: 24,
    marginRight: "auto",
  },
  input: {
    fontSize: 12,
    width: "calc(100% - 12px)",
  },
  spinButtonWrapper: {
    height: 22,
    marginRight: 15,
    marginLeft: 0,
  },
  arrowButtonsContainer: {
    width: 12,
    minWidth: 12,
  },
};

const buttonSmallStyles: Partial<IButtonStyles> = {
  root: {
    width: 12,
    minWidth: 12,
    height: 11,
  },
};

export const getSpinButtonSizedStyles = memoizeFunction(
  (
    size: ActionControlSize | undefined,
    externalStyles: Partial<ISpinButtonStyles> | undefined
  ): SpinButtonSizedStyles => {
    if (!size) {
      return {
        spinButtonStyles: externalStyles,
        buttonStyles: undefined,
      };
    }

    return {
      spinButtonStyles: mergeStyleSets(spinButtonSmallStyles, externalStyles),
      buttonStyles: buttonSmallStyles,
    };
  }
);
